var _defs, _rect, _rect2, _polygon, _polygon2, _polyline, _rect3, _line, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousliving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.09,
    y: 106.4,
    width: 118.86,
    height: 113.83
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.95,
    y: 149.6,
    width: 65.6,
    height: 70.63
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175.04 105.98 18 105.98 96.52 35.77 96.52 35.77 175.04 105.98"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.75 105.57 155.95 134.9 155.95 149.6 238 149.6 188.75 105.57"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "130.72 66.35 130.72 48.65 153.83 48.65 153.83 87.02"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.72,
    y: 172.04,
    width: 35.59,
    height: 48.19
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.96,
    y1: 194.68,
    x2: 105.78,
    y2: 194.68
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.18,
    y: 196.55,
    width: 41.13,
    height: 10.39
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.18,
    y: 206.93,
    width: 41.13,
    height: 11.22
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.18,
    y: 172.04,
    width: 41.13,
    height: 11.63
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.18,
    y: 183.67,
    width: 41.13,
    height: 12.88
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.57,
    y: 119.07,
    width: 19.01,
    height: 19.32
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.57,
    y: 119.07,
    width: 19.01,
    height: 19.32
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.57,
    y: 138.39,
    width: 19.01,
    height: 19.32
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.57,
    y: 138.39,
    width: 19.01,
    height: 19.32
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.73,
    y: 119.07,
    width: 19.01,
    height: 19.32
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.74,
    y: 138.39,
    width: 19.01,
    height: 19.32
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.74,
    y: 119.07,
    width: 19.01,
    height: 19.32
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.73,
    y: 138.39,
    width: 19.01,
    height: 19.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousliving);
export default __webpack_public_path__ + "static/media/previousliving.0cea2e3d3b88a4459e99c4e27ccdfe50.svg";
export { ForwardRef as ReactComponent };